import { nanoid } from "nanoid/non-secure";
import { Recipe } from "./Recipe";

class Meal {
  _id: string;
  _rev: string | null;
  recipe: Recipe;
  constructor(recipe: Recipe) {
    this.recipe = recipe;
    this._id = "Meal:" + nanoid();
  }
}

export { Meal };
